<template>
    <div class="modal is-active">
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">
                    {{ $t("capture-signature.title") }}
                </p>
            </header>
            <section class="modal-card-body">
                <div>
                    <SignaturePad ref="signaturePad" />
                </div>
            </section>
            <footer class="modal-card-foot is-justify-content-flex-end">
                <button class="button is-success" @click="save">
                    <span> {{ $t("capture-signature.sign") }}</span>
                </button>
            </footer>
        </div>
    </div>
</template>

<script>
import SignaturePad from "./SignaturePad.vue";

export default {
    name: "capture-signature",
    components: {
        SignaturePad,
    },
    methods: {
        save() {
            let signature = this.$refs.signaturePad.getSignature();
            this.$emit("captured", signature);
        },
    },
};
</script>